// // import BRANDING from "../Variables";
// // export function getBranding() {
// //   const host = window.location.hostname; 

// //   if (host === "localhost" || host === "127.0.0.1") {
// //     return BRANDING.alhamedglobal; 
// //   }

// //   const parts = host.split(".");

// //   const subdomain = parts.length > 2 ? parts[0] : "default";

// //   return BRANDING[subdomain] || BRANDING.default;
// // }

// import BRANDING from "../Variables";

// export function getBranding() {
//   const host = window.location.hostname; 

//   // Handle localhost development
//   if (host === "localhost" || host === "127.0.0.1") {
//     return BRANDING.equinox; 
//   }

//   const parts = host.split(".");
//   let subdomain;

//   if (parts.includes("alhamedglobal")) {
//     subdomain = "alhamedglobal";
//   } else if (parts.includes("ezim")) {
//     subdomain = "ezims";
//   } else {
//     subdomain = parts.length > 2 ? parts[0] : "default";
//   }

//   return BRANDING[subdomain] || BRANDING.default;
// }


import BRANDING from "../Variables";

export function getBranding() {
  const host = window.location.hostname; 

  // Handle localhost development
  if (host === "localhost" || host === "localhost:3000") {
    return BRANDING.default; 
  }

  // Check for web.topupbox.cm specifically
  if (host === "web.topupbox.com") {
    return BRANDING.default;
  }

  const parts = host.split(".");
  let subdomain;

  if (parts.includes("alhamedglobal")) {
    subdomain = "alhamedglobal";
  } else if (parts.includes("ezim")) {
    subdomain = "ezims";
  } else {
    subdomain = parts.length > 2 ? parts[0] : "default";
  }

  return BRANDING[subdomain] || BRANDING.default;
}